module.exports = __webpack_public_path__ + "src/assets/images/folder_icon.16b3a8756970043a269b68def81599db.svg";